import { UserManager } from "@forgerock/javascript-sdk";
import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../Contexts/AuthContext";
import { CircularProgress } from "@mui/material";
import { useIdleTimer } from "react-idle-timer";
import { useEffect, useState } from "react";

function useAuthValidation(auth, setAuth) {
  const [validity, setValidity] = useState("unknown");

  useEffect(() => {
    async function validateAccessToken() {
      if (auth) {
        try {
          await UserManager.getCurrentUser();
          setValidity("valid");
        } catch (err) {
          setAuth(false);
          setValidity("invalid");
        }
      } else {
        setValidity("invalid");
        setAuth(false);
      }
    }

    validateAccessToken();
  }, [auth]);

  return validity;
}

function SessionLoader() {
  return (
    <div className="h-screen sm:bg-[#E7EEFA] flex flex-col justify-center items-center p-6">
      <CircularProgress />
      <p className="pt-2">Checking user session...</p>
    </div>
  );
}

const PrivateRoutes = () => {
  const { isAuthenticated, setIsAuthenticated, logout } = useAuth();
  const validity = useAuthValidation(isAuthenticated, setIsAuthenticated);

  const onIdle = () => {
    if (isAuthenticated) {
      logout(true, "inactivity");
    }
  };

  useIdleTimer({
    onIdle,
    timeout: 1000 * 60 * 20,
    throttle: 500,
  });

  switch (validity) {
    case "valid":
      return <Outlet />;
    case "invalid":
      return <Navigate to="/" />;
    default:
      return <SessionLoader />;
  }
};

export default PrivateRoutes;
